import { request } from "./client";

export const updateLeaguePayoutConfig = async ({
  leagueId,
  payoutMethod,
  venmoHandle,
}) => {
  return request(`/payments/leagues/${leagueId}/payout-config`, {
    method: "PATCH",
    body: JSON.stringify({ payoutMethod, venmoHandle }),
  });
};

export const selfReportPayment = async (registrationId, { amountCents, paymentNote }) => {
  return request(`/payments/games/registrations/${registrationId}/payment-intent`, {
    method: "POST",
    body: JSON.stringify({ amountCents, paymentNote }),
  });
};

export const updatePaymentStatus = async (paymentId, status) => {
  return request(`/payments/${paymentId}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
};

export const getLeaguePayments = async (leagueId) => {
  return request(`/payments/leagues/${leagueId}/payments`);
};
